export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";
export const SML_AUTH_HEADER_KEY = "Basic c21saWNybTpTbWxpQENSTTI0";
export const BUCKET_URL = "https://vahan-pro.s3.ap-south-1.amazonaws.com/";

export const USERS = { ADMIN: "admin", VENDOR: "vendor", CUSTOMER: "customer" };
export const APIS = {
  AUTH: {
    LOGIN: "/admin/login",
    VENDOR_LOGIN: "/vendor/login",
  },

  VENDORS: {
    ADDEDIT_VENDOR: "/admin/addEditVendor",
  },

  VENDORS_LINK: {
    USERS: "/vendor/listUsers",
    ADDEDIT_USERS: "/vendor/registerUser",
  },

  ADMIN_BLOCKDELETEDATA: "/admin/blockDeleteData",

  ADMIN_LINK: {
    LISTDATA: "/admin/listData",
    ADDEDIT_ADMINS: "/admin/addEditAdmins",
  },

  DESTINATION_AND_QUOTA: {
    LISTING: "/vendor/listDesignations",
    ADDEDIT_DESTINATION_AND_QUOTA: "/vendor/addEditDesignation",
  },
  BULK_UPLOAD : "/vendor/bulkUpload",
  BULK_UPLOAD_LOGS : "/vendor/bulkLogs",
  EXPORT_DATA : "/vendor/exportData",
  ADMIN: {
    CREATE_ADMIN: "/admin/create",
    DELETE_ADMIN: "/admin/delete",
    EDIT_ADMIN: "/admin/editAdmin",
  },
 
  ADMIN_LIST: "/admin/getAdmin",
  LIST_VENDORS: "/admin/listData",

  
  VENDOR_DASHBOARD: "/vendor/dashboard",

  // Vehicle Lookup
  VEHICLE_LOOKUP: "/vendor/rc-full",
  VEHICLE_PDF_DOWNLOAD: "/vendor/vehiclePdf",
  VENDOR_WALLET_BALANCE: "/vendor/walletBalance",

  // Driving Licence
  DRIVING_LICENSE: "/vendor/drivingLicense",

  VENDOR_CHANGE_PASSWORD: "/vendor/changePassword",

  // B2B API Logs
  B2B_API_LOGS: "/vendor/b2bApiLogs",

  // Vehicle Management
  VEHICLE_MANAGEMENT: {
    SEARCH: "/vendor/searchMask",
    DETAILS: "/vendor/details",
    CHALLANS: "/vendor/challanSearch",
    FASTAG_JOURNEY: "/vendor/fastagSearch",
  },
};
